import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { leaderboardApi } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {

  constructor(private apiService: ApiService) { }

  getGeneralLeaderboard(companyId: String, userType) {
    return this.apiService.get(`${leaderboardApi.getGeneralLeaderboard}${companyId}?console=${userType}`);
  }

  getMngrChallngLdbrd(userId: String) {
    return this.apiService.get(`${leaderboardApi.getMngrChallngLdbrd}${userId}`);
  }

  getManagerChallengesByType(userId: String, challengeType: String,compId) {
   
    let pamCompId;
    if(compId){
      pamCompId=compId;
      return this.apiService.get(`${leaderboardApi.getMngrChallngLdbrd}${userId}/${challengeType}?companyId=${pamCompId}`);
    }else{
      return this.apiService.get(`${leaderboardApi.getMngrChallngLdbrd}${userId}/${challengeType}`);
    }

  }

  getSellerChallengesByType(userId: String, challengeType: String) {
    return this.apiService.get(`${leaderboardApi.getSellerChallngLdbrd}${userId}/${challengeType}`);
  }

  getSellerChallngLdbrd(userId: String) {
    return this.apiService.get(`${leaderboardApi.getSellerChallngLdbrd}${userId}`);
  }

  getMoreLeaderboards(reqObj) {
    return this.apiService.get(`${leaderboardApi.getGeneralLeaderboard}${reqObj.companyId}/${reqObj.type}?page=${reqObj.page}&size=${reqObj.size}`);
  }

  getMoreManagerChallng(reqObj) {
    return this.apiService.get(`${leaderboardApi.getMngrChallngLdbrd}${reqObj.userId}/${reqObj.type}/${reqObj.itemId}?page=${reqObj.page}&size=${reqObj.size}`);
  }

  getMoreSellerChallng(reqObj) {
    return this.apiService.get(`${leaderboardApi.getSellerChallngLdbrd}${reqObj.userId}/${reqObj.type}/${reqObj.itemId}?page=${reqObj.page}&size=${reqObj.size}`);
  }

  getMoreChallenges(pathParams, queryParams) {
    if(pathParams.companyId){
      return this.apiService.get(`${leaderboardApi.getMoreChallenges}${pathParams.type}/${pathParams.challengeId}?companyId=${pathParams.companyId}`, queryParams);
    }else{
      return this.apiService.get(`${leaderboardApi.getMoreChallenges}${pathParams.type}/${pathParams.challengeId}`, queryParams);
    }
  
  }

  getActivationChallenges(companyId, queryParams) {
    return this.apiService.get(`${leaderboardApi.getActivationChallenges}${companyId}`, queryParams);
  }

  getTopCiscoBookings( queryParams) {
    return this.apiService.get(`${leaderboardApi.getTopCiscoBookings}`,queryParams);
  }

  getFiscalDropDownList() {
    return this.apiService.get(`${leaderboardApi.getFiscalDropDownList}`);
  }
  getFiscalPamDropdownList(){
    return this.apiService.get(`${leaderboardApi.getFiscalPamDropdownList}`);
  }
  getPartnersLeaderboardData(queryParams){
    return this.apiService.get(`${leaderboardApi.getPartnersLeaderboardData}${queryParams}`);
  }
  getdistiChallengeRequest(body){
    return this.apiService.get(`${leaderboardApi.distributionLeaderboard}${body}`);

  }
  getquaterListForDistributorChgFlag(body){
    return this.apiService.get(`${leaderboardApi.leaderboardQuaterList}${body}`); 
  }
  getActivityLeaderboardChallengeTypes(req){
    return this.apiService.get(`${leaderboardApi.activityLeaderboardChagTypes}${req}`); 
  }
  getActivityLeaderboardSubCategory(req){
    return this.apiService.get(`${leaderboardApi.activityLeaderboardSubCategory}${req}`); 
  }
  getSalesLeaderBoardList(companyId: String, userType){
    return this.apiService.get(`${leaderboardApi.getSalesLeaderboardList}${companyId}?console=${userType}`);
  }
  getSalesLeaderboardData(reqObj){
    return this.apiService.get(`${leaderboardApi.getSalesLeaderboardData}${reqObj}`,);
  }
  getLeaderboardChallengeList(req){
    return this.apiService.get(`${leaderboardApi.LeaderboardChallenges}${req}`);
  }
  getLeaderboardChallengeData(req){
    return this.apiService.get(`${leaderboardApi.leaderboardChallengeData}${req}`);
  }
  getLeaderboardChgSubcategoryData(req){
    return this.apiService.get(`${leaderboardApi.leaderboardChgsSubcategoryData}${req}`);
  }
  getLeaderboardRankDetails(req){
    return this.apiService.get(`${leaderboardApi.leaderboardRankDetails}${req}`);
  }
  getActivityLeaderboardRankDetails(req){
    return this.apiService.get(`${leaderboardApi.activityLeaderboardRankDetails}${req}`);
  }
  uploadLeaderboardChgDocuments(filedata, params){

    return this.apiService.postForFile(
      `${leaderboardApi.uploadLeaderboardDocuments}${params}`, filedata
    )
  }
}
